import React from 'react'
import Page from '../components/Page'
import { Spinner, Button, ButtonGroup, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
// import axios from 'axios';
import axios from '../utils/posAxios'
import moment from 'moment-timezone'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdWarning, MdClear, MdCreate, MdKeyboardReturn, MdDelete, MdFileUpload, MdCancel } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import { getProductList, getProductCategory, getProductType } from '../utils/dropdownlist'
import update, { extend } from 'immutability-helper'
import Compress from 'compress.js'

import '../../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../../node_modules/@syncfusion/ej2-icons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css'
import '../../node_modules/@syncfusion/ej2-lists/styles/material.css'
import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css'
import '../../node_modules/@syncfusion/ej2-popups/styles/material.css'
import '../../node_modules/@syncfusion/ej2-richtexteditor/styles/material.css'
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar, NodeSelection, PasteCleanup } from '@syncfusion/ej2-react-richtexteditor'

import EasyParcelRequestOrder from './EasyParcelRequestOrder'

const compress = new Compress()

class PosEasyParcelForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      requestModal: false,
      disable: false,
      store_id: this.props.data.store_id,
      order_id: this.props.data.order_id,
      delivery_collection_point: [],
      collection_point: '',
      schedule: {},
      items: [],
      total_price: '',
      pick_code: '',
      pick_country: '',
      send_code: '',
      send_country: 'SG',
      date_coll: '',
      weight: '',
      width: '',
      height: '',
      length: '',
      rates: [],
    }
  }

  componentDidMount() {
    this.DeliveryCollection()
    console.log(this.props)
    let data = this.props.data
    let { address, schedule, items, total_price } = data

    this.setState({
      schedule: schedule,
      address: address,
      items: items,
      total_price: total_price,
      send_code: address.postal_code,
      date_coll: schedule && schedule.hasOwnProperty('schedule_date') ? moment(schedule.schedule_date, 'DD/MM/YYYY').tz('Asia/Singapore').format('YYYY-MM-DD') : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
    })
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  collection_point_handler = event => {
    const { name, value } = event.target
    let location = this.state.delivery_collection_point.find(x => x.id == value)

    this.setState({
      [name]: value,
      pick_code: location.pick_code,
      pick_country: location.pick_country,
    })
  }

  changeHandler = event => {
    const { name, value } = event.target

    this.setState({
      [name]: value,
    })
  }

  checkHandler = e => {
    let { name } = e.target
    this.setState({
      [name]: !this.state[name],
    })
  }

  CalWeight() {
    let { width, length, height } = this.state

    let weight = (parseFloat(width) * parseFloat(length) * parseFloat(height)) / 5000
    if (isNaN(weight) == false) {
      this.setState({
        weight: weight,
      })
    } else {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Please fill in width, length and height.',
        level: 'warning',
        position: 'tc',
        autoDismiss: 4,
        dismissible: 'click',
      })
    }
  }

  closeModal = (title, message, level, reload) => {
    // this.notificationSystem.addNotification({
    //   title: title,
    //   message: message,
    //   level: level,
    //   position: 'br',
    //   autoDismiss: 2,
    //   dismissible: 'click',
    // })

    // this.setState({
    //   requestModal: false,
    // })

    this.props.closeModal(title, message, level, true)

    // if (reload) {
    //   setTimeout(() => this.setState({ redirectToProduct: true }), 1000)
    // } else {
    //   this.getProduct()
    // }
  }

  DeliveryCollection() {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
    }
    axios
      .post(url + ':3003/v1/order/delivery/pickaddress', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            delivery_collection_point: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  handleSubmit = event => {
    event.preventDefault()

    this.setState({ isLoading: true })

    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const comp = StorageService.getSession('selected_org')
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      package: {
        weight: this.state.weight,
        width: this.state.width,
        height: this.state.height,
        length: this.state.length,
      },
      pick_code: this.state.pick_code,
      pick_country: this.state.pick_country,
      send_code: this.state.send_code,
      send_country: this.state.send_country,
      date_coll: this.state.date_coll,
    }

    axios
      .post(url + ':3003/v1/order/delivery/ezp/checkrate', data)
      .then(response => {
        const result = response.data
        if (result.data.status != 'Success') {
          //alert(result.data.remarks)
          alert('There is no delivery partner configured. Please contact us for more information.')
          return
        } else {
          if (this._isMounted) {
            this.setState({
              rates: result.data.rates,
              isLoading: false,
              disable: true,
            })
          }
        }
      })
      .then(() => {
        this.setState({ isLoading: false })
      })
      .catch(error => {
        this.setState({ isLoading: false })
        alert(error)
      })
  }

  requestModal = SelectedID => () => {
    return this.setState({
      requestModal: !this.state.requestModal,
      SelectedID: SelectedID,
    })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <ModalHeader toggle={this.props.onToggleModal(true)}>EasyParcel Quote</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Collection Point</Label>
                <Input type="select" name="collection_point" value={this.state.collection_point} onChange={this.collection_point_handler} required>
                  <option></option>
                  {this.state.delivery_collection_point.map(item => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.pick_name}
                      </option>
                    )
                  })}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Pick Postal Code</Label>
                <Input type="text" name="pick_code" value={this.state.pick_code} readOnly />
              </FormGroup>

              <FormGroup>
                <Label>Pick Country</Label>
                <Input type="text" name="pick_country" value={this.state.pick_country} readOnly />
              </FormGroup>

              <FormGroup>
                <Label>Receiver Postal Code*</Label>
                <Input type="text" name="send_code" value={this.state.send_code} onChange={this.changeHandler} readOnly={this.state.disable} required />
              </FormGroup>

              <FormGroup>
                <Label>Receiver Country*</Label>
                <Input type="select" name="send_country" value={this.state.send_country} onChange={this.changeHandler} readOnly={this.state.disable} required>
                  <option></option>
                  <option value="SG">SG</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>Collection Date</Label>
                <Input type="date" name="date_coll" value={this.state.date_coll} onChange={this.changeHandler} required />
              </FormGroup>

              <Row form>
                <Col md={3}>
                  <FormGroup>
                    <Label>Width (cm)</Label>
                    <Input type="number" name="width" value={this.state.width} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Length (cm)</Label>
                    <Input type="number" name="length" value={this.state.length} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Height (cm)</Label>
                    <Input type="number" name="height" value={this.state.height} onChange={this.changeHandler} />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label></Label>
                    <div className="form-control" style={{ border: 'none' }}>
                      <Button onClick={() => this.CalWeight()}>Calculate</Button>
                    </div>
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label>Package Weight* (kg)</Label>
                <Input type="text" name="weight" value={this.state.weight} onChange={this.changeHandler} required />
                <span>*Weight will be determined by actual or volumetric weight whichever higher</span>
              </FormGroup>

              <Row style={{ float: 'right' }}>
                <Col>
                  <ButtonGroup>
                    <Button className="theme-button unity-theme-button-primary" type="submit">
                      Get Quote
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>

              <Table responsive hover className="ps-table tb-col-5">
                <thead>
                  <tr>
                    <th>Courier</th>
                    <th>
                      Pickup Date
                      <br /> Schedule Start
                    </th>
                    <th>Delivery</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.rates.length > 0 &&
                    this.state.rates.map((item, index) => {
                      return (
                        <tr key={item.rate_id}>
                          <td>
                            <img src={item.courier_logo} style={{ width: '50%' }} />
                            <br />
                            {item.service_name}
                          </td>
                          <td>
                            {item.pickup_date}
                            <br />
                            {item.scheduled_start_date}
                          </td>
                          <td>{item.delivery}</td>
                          <td>{item.price}</td>
                          <td>
                            <div className="ps-action-button">
                              <Button className="theme-button theme-button-primary-light" onClick={this.requestModal(item.service_id)}>
                                select
                              </Button>
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </Table>
            </Col>
          </Row>

          <Modal isOpen={this.state.requestModal} className="modal-lg" centered>
            <EasyParcelRequestOrder history={this.props.history} onToggleModal={this.requestModal} closeModal={this.closeModal} match={this.props.match} data={this.state} />
          </Modal>
        </ModalBody>
        <ModalFooter>
          {/* <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button> */}
          {/* <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button> */}
        </ModalFooter>
      </Form>
    )
  }
}
export default PosEasyParcelForm
